import { useEffect } from 'react';
import { useWtrSelector } from 'redux/hooks';
import usePrevious from 'hooks/use-previous';
import { getCustomerSlotBranchId } from 'redux/modules/customer-slot/selectors';

const NO_BRANCH = 'no_branch';

export const useOnCancelAmends = (onChange: () => void) => {
  const customerSlotBranchId = useWtrSelector(getCustomerSlotBranchId);
  const branchId = customerSlotBranchId ?? NO_BRANCH;
  const previousCustomerSlotBranchId = usePrevious(branchId);

  useEffect(() => {
    if (
      typeof previousCustomerSlotBranchId !== 'undefined' &&
      previousCustomerSlotBranchId !== branchId &&
      branchId === NO_BRANCH
    ) {
      onChange();
    }
  }, [branchId, onChange, previousCustomerSlotBranchId]);
};
